import { JsonObject, JsonProperty } from 'json2typescript';
import { Pagination } from '../../shared/pagination-model';

@JsonObject('SoupConfigurationFilters')
export class SoupConfigurationFilters extends Pagination {
  @JsonProperty('supplier', String, true) supplier: string = undefined;
  @JsonProperty('routeType', String, true) routeType: string = undefined;
  @JsonProperty('active', Boolean, true) active: boolean = undefined;
}
